import { Component } from '@angular/core';

@Component({
  selector: 'app-support',
  standalone: false,
  templateUrl: './support.html',
  styleUrl: './support.scss',
})
export class Support {}
